import {
  MODAL_INTEGRATIONS,
  MODAL_PRICING,
} from '@components/App/Modal/constants'
import openWelcome from '@components/App/Welcome'
import { AuthActions } from '@store/reducers/auth'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

import { createSwitch } from '@/utils'

export const useUserMenuActions = (toggleSpy: () => void) => {
  const dispatch = useDispatch()

  const logout = () => {
    dispatch(AuthActions.logout())
  }

  const switcher = createSwitch()
    .case(['logout'], logout)
    .case(['about'], openWelcome)
    .case(['integrations'], () => dispatch(openModal(MODAL_INTEGRATIONS)))
    .case(['pricing'], () => dispatch(openModal(MODAL_PRICING)))
    .case(['spy_mode'], toggleSpy)

  const onClick = (path: string[]) => switcher.run(path)

  return { onClick }
}
